import styled from 'styled-components'

function Terms5() {
  return (
    <ContactWrapper>
      <div id="wrapper">
        <div class="contents" id="fullpage" data-ui-parellax="wrapper">
          <div class="contents--outer-wrap section">
            <div class="contents-wrapper">
              <article style={{ lineHeight: '2rem', paddingTop: '2rem' }}>
                <p>
                  <b>아동 안전 표준 정책</b>
                </p>
                <p>
                  <span>&nbsp;</span>
                </p>
                <p>
                  <b>1. 정책 목적</b>
                </p>
                <p>
                  에스프레스토㈜는 (이하 “회사”라 함) 이용자가 안전하게 이용할
                  수 있는 서비스를 제공합니다.
                </p>
                <p>
                  본 정책은 아동 성적 학대 및 착취 행위를 예방하고, 관련
                  콘텐츠를 철저히 금지하기 위해 마련되었습니다.
                </p>
                <p>
                  <br />
                  <b>2. 금지되는 행위</b>
                </p>
                <p>
                  - 아동 성적 학대 또는 착취를 묘사하거나 조장하는 콘텐츠
                  업로드, 전송, 공유 등
                </p>
                <p>- 미성년자를 성적인 맥락으로 유인하거나 접근하는 행위</p>
                <p>
                  - 아동의 나체 이미지, 선정적 포즈 또는 성적 암시를 담은 콘텐츠
                  게시
                </p>
                <p>
                  - CASM 또는 CSAE 관련 자료의 링크 공유, 요청 또는 제3자 전송
                </p>
                <p>- 기타 국내외 아동 보호법을 위반하는 행위</p>
                <p>
                  <br />
                  <b>3. 금지 행위의 대응 방법</b>
                </p>
                <p>
                  회사는 2조의 행위를 행한 이용자 또는 콘텐츠 등에 대해 다음과
                  같은 조치를 진행합니다.
                </p>
                <p>- 콘텐츠 삭제 및 사용자 계정 정지</p>
                <p>- 금지된 행위의 심각성을 확인 후 서비스 영구 이용 제한</p>
                <p>
                  <br />
                  <b>4. 금지행위 제보 방법</b>
                </p>
                <p>
                  사용자는 앱 내 또는 이메일을 통해 CASM, CSAE 관련 콘텐츠를
                  제보할 수 있습니다.
                </p>
                <p>- 앱 내부 경로: 프로필 화면 &gt; 설정 &gt; 하단 문의하기</p>
                <p>
                  - 이메일:{' '}
                  <a href="mailto:contact@spresto.net">contact@spresto.net</a>
                </p>
                <p>
                  신고 접수 시, 담당자는 가능한 한 빠르게 검토 후 조치하며, 법적
                  의무에 따라 관계 기관에 보고할 수 있습니다.
                </p>
                <p>
                  <br />
                  <b>5. 법적 준수</b>
                </p>
                <p>
                  회사는 대한민국 [아동-청소년의 성보호 관한 법률]을 비롯하여
                  아동 보호 지침 및 법률을 준수합니다.
                </p>
                <p>
                  <b>6. 아동 안전 보호 책임자 및 담당자 연락처</b>
                </p>
                <p>- 담당자: 박성환</p>
                <p>- 부서명: 운영팀</p>
                <p>
                  - 이메일:{' '}
                  <a href="mailto:shpark@spresto.net">shpark@spresto.net</a>
                </p>
                <p>
                  <br />
                  <b>7. 정책 개정</b>
                </p>
                <p>
                  회사는 법령 변경이나 서비스 개선을 위해 본 정책을 수정할 수
                  있으며, 중요한 변경이 있을 경우 사전에 공지합니다.
                </p>
              </article>
            </div>
          </div>
        </div>
      </div>
    </ContactWrapper>
  )
}

const ContactWrapper = styled.section`
  position: relative;
  min-width: 1440px;
  padding: 0 60px 0 60px;
  background-color: ${(props) => props.theme.color.WPrimary};
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 100px;

  @media all and (max-width: 1024px) {
    word-break: keep-all;
    min-width: 100%;
    width: 100%;
    margin-top: 3.5rem;
    padding: 0 1.5rem;
  }
`

export default Terms5
